// extracted by mini-css-extract-plugin
export default {"container":"PageInPopup__container--2VJ","error":"PageInPopup__error--1l6"};